import { create } from 'zustand';

type Multi<T> = T[] | undefined;

export type Filters = {
  bairros: Multi<string>;
  h3: Multi<string>;
  unitTypes: Multi<string>;
  bedrooms: Multi<number>;
  bathrooms: Multi<number>;
  parking: Multi<number>;
  floor: Multi<number>;
  priceRange: Multi<number>;
  priceTotalTier: Multi<string>;
  areaTier: Multi<string>;
};

type FiltersStore = { filters: Filters; set: (p: Partial<Filters>) => void };

export const useFilters = create<FiltersStore>((set) => ({
  filters: {
    bairros: undefined,
    h3: undefined,
    unitTypes: undefined,
    bedrooms: undefined,
    bathrooms: undefined,
    parking: undefined,
    floor: undefined,
    priceRange: undefined,
    priceTotalTier: undefined,
    areaTier: undefined,
  },
  set: (p) => set((s) => ({ ...s, filters: { ...s.filters, ...p } })),
}));

export function whereClause(f: Filters, exclude?: (keyof Filters)[]): string {
  const x: string[] = [];
  if (f.bairros?.length && !exclude?.includes('bairros')) x.push(`bairro IN (${f.bairros.map((v) => `'${v.replace(/'/g, "''")}'`).join(',')})`);
  if (f.h3?.length && !exclude?.includes('h3')) x.push(`h3_7 IN (${f.h3.map((v) => `'${v}'`).join(',')})`);
  if (f.unitTypes?.length && !exclude?.includes('unitTypes')) x.push(`unit_type IN (${f.unitTypes.map((v) => `'${v}'`).join(',')})`);
  if (f.bedrooms?.length && !exclude?.includes('bedrooms')) x.push(`bedrooms_bin IN (${f.bedrooms.join(',')})`);
  if (f.bathrooms?.length && !exclude?.includes('bathrooms')) x.push(`bathrooms_bin IN (${f.bathrooms.join(',')})`);
  if (f.parking?.length && !exclude?.includes('parking')) x.push(`parking_bin IN (${f.parking.join(',')})`);
  if (f.floor?.length && !exclude?.includes('floor')) x.push(`floor_level IN (${f.floor.join(',')})`);
  if (f.priceRange?.length && !exclude?.includes('priceRange')) {
    const hasHundredPlus = f.priceRange.includes(100);
    const under100 = f.priceRange.filter(v => v < 100);
    if (hasHundredPlus && under100.length > 0) {
      x.push(`(price_m2_bucket IN (${under100.join(',')}) OR price_m2_bucket >= 100)`);
    } else if (hasHundredPlus) {
      x.push(`price_m2_bucket >= 100`);
    } else if (under100.length > 0) {
      x.push(`price_m2_bucket IN (${under100.join(',')})`);
    }
  }
  if (f.priceTotalTier?.length && !exclude?.includes('priceTotalTier')) {
    x.push(`price_total_tier IN (${f.priceTotalTier.map((v) => `'${v}'`).join(',')})`);
  }
  if (f.areaTier?.length && !exclude?.includes('areaTier')) {
    x.push(`area_tier IN (${f.areaTier.map((v) => `'${v.replace(/'/g, "''")}'`).join(',')})`);
  }
  return x.length ? `WHERE ${x.join(' AND ')}` : '';
}


